import _setInterval from "@babel/runtime-corejs3/core-js-stable/set-interval";
import React from 'react';
import cx from 'classnames';
import humanize from 'humanize-num';
import IsInvertedProvider from "../is-inverted-provider";
import Tooltip from "../../core/tooltip";
import { createComponent, PropTypes } from "../../../wayin-react"; // import enums

import { colors, positions, font, sizes } from "../../../enums"; //import components

import Label from "../../core/label";
import Header from "../../core/header"; // create component

var Counter = createComponent({
  displayName: 'CounterCmp',
  propTypes: {
    animationDuration: PropTypes.number,
    animationFragmentInterval: PropTypes.number,
    counterValue: PropTypes.number.isRequired,
    tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    emptyValue: PropTypes.string,
    font: PropTypes.shape({
      family: PropTypes.oneOf(font.families.ALL),
      emphasis: PropTypes.oneOf(font.emphasis.ALL),
      weight: PropTypes.oneOf(font.weights.ALL)
    }),
    formatterFunction: PropTypes.func,
    size: PropTypes.oneOf([sizes.X5, sizes.X6, sizes.X7, sizes.X8]),
    // no point in smaller sizes really
    header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    byline: PropTypes.string,
    zeroValue: PropTypes.string
  },
  defaultProps: {
    animationDuration: 1000,
    animationFragmentInterval: 100,
    tooltip: undefined,
    emptyValue: '--',
    font: {
      family: font.families.SYSTEM,
      emphasis: font.emphasis.NORMAL,
      weight: font.weights.REGULAR
    },
    formatterFunction: function formatterFunction(value) {
      return humanize(value);
    },
    size: sizes.X8,
    header: undefined,
    byline: undefined,
    zeroValue: '--'
  },
  state: {
    maxAnimCount: {
      value: function value(p) {
        return Math.floor(p.animationDuration / p.animationFragmentInterval);
      },
      updater: 'setMaxAnimCount'
    },
    currentAnimValue: undefined,
    currentAnimFormattedValue: {
      value: undefined,
      updater: function updater(_updater, p) {
        return {
          setCurrentAnimFormattedValue: function setCurrentAnimFormattedValue(animValueTo) {
            var _outValue = 0;
            if (p.formatterFunction && animValueTo !== null) _outValue = p.formatterFunction(animValueTo);
            return Number(_outValue) === 0 ? _updater(p.zeroValue) : _updater(_outValue);
          }
        };
      }
    },
    runningAnimIndex: false
  },
  lifecycles: {
    componentDidMount: function componentDidMount() {
      this.props.animateCounter(this.props.counterValue);
    },
    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.counterValue !== nextProps.counterValue) {
        this.props.animateCounter(nextProps.counterValue);
      }
    },
    componentWillUnmount: function componentWillUnmount() {
      if (this.props.runningAnimIndex !== false) clearInterval(this.props.runningAnimIndex);
    }
  },
  handlers: {
    animateCounter: function animateCounter(p) {
      return function (counterValue) {
        var animValueTo = isNaN(counterValue) ? 0 : counterValue;
        var animCount;
        var animValueFrom;
        var animValueIncrement; // check for an existing animation cycle and clear the interval if you find one

        if (p.runningAnimIndex !== false) clearInterval(p.runningAnimIndex);

        if (!isNaN(animValueTo)) {
          animCount = 0;
          animValueFrom = isNaN(p.currentAnimValue) ? 0 : p.currentAnimValue;
          animValueIncrement = Math.floor((animValueTo - animValueFrom) / p.maxAnimCount);
        }

        var interval = _setInterval(function () {
          var animValue = Math.floor(animValueFrom + animCount * animValueIncrement);
          animCount++;

          if (animCount > p.maxAnimCount) {
            clearInterval(interval);
            p.setRunningAnimIndex(null);
            p.setCurrentAnimValue(animValueTo);
            p.setCurrentAnimFormattedValue(animValueTo);
          } else {
            p.setCurrentAnimValue(animValue);
            p.setCurrentAnimFormattedValue(animValue);
          }
        }, p.animationFragmentInterval);

        p.setRunningAnimIndex(interval);
      };
    }
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(p) {
    var _cx2, _cx3;

    var _cx = cx({
      ck: true,
      counter: true,
      inverted: p.isInverted
    });

    var _cxValue = cx((_cx2 = {
      'counter-value': true
    }, _cx2["counter-value--" + p.size] = true, _cx2));

    var _cxTitle = cx((_cx3 = {
      'counter-title': true
    }, _cx3["counter-title--" + p.size] = true, _cx3));

    return /*#__PURE__*/React.createElement("div", {
      className: _cx
    }, /*#__PURE__*/React.createElement("div", {
      className: "counter__inner"
    }, /*#__PURE__*/React.createElement("div", {
      className: _cxValue
    }, /*#__PURE__*/React.isValidElement(p.tooltip) ? [p.tooltip, /*#__PURE__*/React.createElement(Label, {
      text: p.currentAnimFormattedValue,
      font: p.font,
      key: "1"
    })] : /*#__PURE__*/React.createElement(Tooltip, {
      tooltip: p.tooltip,
      position: positions.TOP
    }, /*#__PURE__*/React.createElement(Label, {
      text: p.currentAnimFormattedValue,
      font: p.font,
      color: colors.BASE
    }))), /*#__PURE__*/React.createElement("div", {
      className: _cxTitle
    }, /*#__PURE__*/React.isValidElement(p.header) ? p.header : /*#__PURE__*/React.createElement(Header, {
      text: p.header,
      byline: p.byline,
      size: p.size,
      font: {
        family: font.families.CUSTOM,
        emphasis: font.emphasis.CAPS,
        weight: font.weights.REGULAR
      }
    }))));
  }
});
export var PrivateCounter = Counter;
export default Counter;
//# sourceMappingURL=index.js.map